<template>
    <div class="my-referral-share">
        <div class="my-referral-share__title">Share Code</div>
        <div class="my-referral-share__buttons">
            <ShareButtons :referralCode="referralCode" :baseUrl="baseUrl" />
        </div>
    </div>
</template>

<script setup>
import ShareButtons from '@/components/Referral/Share-Buttons.vue';

defineProps({
    referralCode: {
        type: String,
        required: true
    }
});

const baseUrl = window.location.origin;
</script>